export enum Series {
  LISTED_EXPIRIES = 'Listed Expiries',
  CONSTANT_MATURITIES = 'Constant Maturities',
}
